import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`The DoIt connector can link infrastructure reports to PostHog.`}</p>
    <p>{`To link DoIt:`}</p>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Go to the `}<a parentName="p" {...{
            "href": "https://us.posthog.com/pipeline/sources"
          }}>{`sources tab`}</a>{` of the data pipeline section in PostHog.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Click `}<strong parentName="p">{`+ New source`}</strong>{` and then click `}<strong parentName="p">{`Link`}</strong>{` next to DoIt.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Next, you need an API key from DoIt. To start, in your DoIt dashboard open up the `}<a parentName="p" {...{
            "href": "https://app.doit.com/profile/api"
          }}>{`API key page`}</a>{`, generate a key and note it down - you won't be able to view this key once you leave the page.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Back in PostHog, paste the API key in the `}<inlineCode parentName="p">{`API key`}</inlineCode>{` field and hit `}<strong parentName="p">{`Next`}</strong>{`.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`On the next page, set up the reports you want to sync and modify the method and frequency as needed. Once done, click `}<strong parentName="p">{`Import`}</strong>{`. New reports will show up in your schemas list periodically as they're created on DoIt.`}</p>
      </li>
    </ol>
    <p>{`Once the syncs are complete, you can start using DoIt data in PostHog.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      